import {
    Component,
    input,
    Input
} from '@angular/core';
import {
    FormGroup,
    ReactiveFormsModule,
    FormControl
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ErrorStateMatcher, MatNativeDateModule } from '@angular/material/core';
import {  MatMenuModule } from '@angular/material/menu';
import { TimePickerComponent } from '../time-picker/time-picker.component';

export class TimePickerErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null): boolean {
        if (!(control?.errors))
        {
            return false;
        }

        return !!(control && control.invalid && control.errors?.['invalidTime']);
    }
}

@Component({
    selector: 'lib-time-range-picker',
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatMenuModule,
        TimePickerComponent
    ],
    templateUrl: './time-range-picker.component.html',
    styleUrl: './time-range-picker.component.scss'
})
export class TimeRangePickerComponent {
    @Input() parentFormGroup!: FormGroup;

    containerClass = input<string>();
    startTimeDisabled = input<boolean>(false);
    endTimeDisabled = input<boolean>(false);

    matcher: ErrorStateMatcher = new TimePickerErrorStateMatcher();
    startTimeLabel: string = $localize`Start Time`;
    endTimeLabel: string = $localize`End Time`;

    getStartTimeFomGroup() {
        return this.parentFormGroup.get('startTime') as FormGroup;
    }
    getEndTimeFomGroup() {
        return this.parentFormGroup.get('endTime') as FormGroup;
    }
}